module.exports = __webpack_public_path__ + "static/media/piratas.e7b4175e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/piratas.png
// module id = 133
// module chunks = 0